import { Link } from "react-router-dom";
import Modal from "react-modal";
import { ReactComponent as ConfirmSvg } from "../../../media/confirm.svg";
import "../../../styles/Containers.css";
import TagsForm from "../../addCard/components/TagsForm";
import { useState } from "react";

export default function NinjaModal({
  showNinja,
  handleCloseNinja
}) {
  const [tags, setTags] = useState([]);

  return (
    <Modal
      isOpen={showNinja}
      onRequestClose={handleCloseNinja}
      className="modal"
      overlayClassName="overlay"
    >
      <div className="modal-header">
        <h2>بگو چی داری؟</h2>
        <Link to="" onClick={handleCloseNinja}>
          <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
        </Link>
      </div>
      <div className="modal-body">
        <p className="yekan grey-2 marginTop5 marginBottom3 caption-1">
          دو یا بیشتر مواد اولیه‌ای که توی خونه داری رو اینجا وارد کن
        </p>
        <TagsForm
          tags={tags}
          setTags={setTags}
          inputClass={"b-grey-5 yekan subject-1"}
        />

        <p className="yekan grey-2 marginTop10 marginBottom5 caption-1">
          با زدن دکمه "چی بپزم؟" غذاهاییکه با مواد بالا درست میشه رو بهت پیشنهاد
          میدیم.
        </p>
      </div>
      <div className="modal-footer">
        <Link
          to={`/Ninja?q=${tags}`}
          className="marginBottom0-4r fill-container radius1-5"
        >
          چی بپزم؟
        </Link>
      </div>
    </Modal>
  );
}
